"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processIntersections = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var vecUtil_sidecar_1 = require("@lib/vecUtil-sidecar");
var minigolfCreatures_sidecar_1 = require("../entities/minigolfCreatures-sidecar");
var vectorUtils_sidecar_1 = require("../to-engine/vectorUtils-sidecar");
var minigolfSounds_sidecar_1 = require("../sound/minigolfSounds-sidecar");
var namespace = 'minigolf-intersections-handler';
function processIntersections(world) {
    // Get our puck
    // let puck = minigolfGameState.get().currentPuck
    // if (!puck || puck.isDead) {
    //   return
    // }
    var enemiesAndPlayer = minigolfCreatures_sidecar_1.minigolfCreatures
        .getAll()
        .filter(function (c) { return !c.isDead && c.data.isAffectedBySlopes; });
    var _loop_1 = function (iEntity) {
        var entity = enemiesAndPlayer[iEntity];
        // intersectionsWith
        world.intersectionPairsWith(entity.rigidBody.collider(0), function (otherCollider) {
            // console.log(namespace, 'puck hit collider/sensor')
            var body2 = otherCollider.parent();
            assert_sidecar_1.assert.notNil(entity, 'missing entity');
            if (!body2) {
                console.log(namespace, 'missing collider body!', body2);
                return;
            }
            var userData2 = body2 === null || body2 === void 0 ? void 0 : body2.userData;
            if (!userData2) {
                console.log(namespace, 'missing user data!', userData2);
                return;
            }
            var isPuck = entity.data.isPuck;
            if (userData2.type === 'creature') {
                // console.log(namespace, 'puck hit creature')
                var creature2 = minigolfCreatures_sidecar_1.minigolfCreatures.tryGetFromHandle(body2.handle);
                assert_sidecar_1.assert.notNil(creature2, 'missing creature');
                if (creature2.data.creatureType === 'ghost') {
                    console.log(namespace, 'puck hit ghost');
                    var force = vecUtil_sidecar_1.vecUtil.create(0, 1);
                    force = vecUtil_sidecar_1.vecUtil.rotateTurns(force, rando_sidecar_1.rando.f(0, 1));
                    force = vectorUtils_sidecar_1.vectorUtils.scale(force, 0.01);
                    // console.log(namespace, 'add force', force)
                    if (!minigolfCreatures_sidecar_1.minigolfCreatures.hasEffect(entity, 'ghosted')) {
                        minigolfCreatures_sidecar_1.minigolfCreatures.tryBleed(entity, 'spectral');
                        minigolfCreatures_sidecar_1.minigolfCreatures.addEffect(entity, {
                            type: 'ghosted',
                            timeLeft: 2,
                            vec: force,
                        }, minigolfSounds_sidecar_1.minigolfSounds.playEffectGhosted);
                    }
                    // puck.rigidBody.addForce(force, true)
                }
                if (creature2.data.creatureType === 'jelly') {
                    console.log(namespace, 'creature hit jelly');
                    if (!minigolfCreatures_sidecar_1.minigolfCreatures.hasEffect(entity, 'slowed') &&
                        !entity.state.slowImmuneThisTurn) {
                        minigolfCreatures_sidecar_1.minigolfCreatures.tryBleed(entity, 'slime');
                        minigolfCreatures_sidecar_1.minigolfCreatures.addEffect(entity, {
                            type: 'slowed',
                            timeLeft: 0.5,
                            vec: vecUtil_sidecar_1.vecUtil.create(0, 1),
                        });
                    }
                }
                if (creature2.data.creatureType === 'slime') {
                    console.log(namespace, 'creature hit slime');
                    if (!minigolfCreatures_sidecar_1.minigolfCreatures.hasEffect(entity, 'slowed') &&
                        !entity.state.slowImmuneThisTurn) {
                        minigolfCreatures_sidecar_1.minigolfCreatures.tryBleed(entity, 'slime');
                        minigolfCreatures_sidecar_1.minigolfCreatures.addEffect(entity, {
                            type: 'slowed',
                            timeLeft: 0.5,
                            vec: vecUtil_sidecar_1.vecUtil.create(0, 1),
                        }, isPuck
                            ? minigolfSounds_sidecar_1.minigolfSounds.playSlimed
                            : minigolfSounds_sidecar_1.minigolfSounds.playSlimedQuiet);
                    }
                }
                if (creature2.data.creatureType === 'lava') {
                    console.log(namespace, 'creature hit lava');
                    // if (entity.state.health > 0) {
                    minigolfCreatures_sidecar_1.minigolfCreatures.hurt(entity, 100, 'toasted', true, isPuck
                        ? minigolfSounds_sidecar_1.minigolfSounds.playHitLava
                        : minigolfSounds_sidecar_1.minigolfSounds.playHitLavaQuiet);
                    if (!minigolfCreatures_sidecar_1.minigolfCreatures.hasEffect(entity, 'slowed') &&
                        !entity.state.slowImmuneThisTurn) {
                        minigolfCreatures_sidecar_1.minigolfCreatures.tryBleed(entity, 'lava');
                        minigolfCreatures_sidecar_1.minigolfCreatures.addEffect(entity, {
                            type: 'slowed',
                            timeLeft: 0.5,
                            vec: vecUtil_sidecar_1.vecUtil.create(0, 1),
                            ignoreMssage: true,
                        });
                    }
                    // }
                }
                if (creature2.data.creatureType === 'slope') {
                    console.log(namespace, 'creature hit slope');
                    var direction = vecUtil_sidecar_1.vecUtil.create(-1, 0);
                    direction = vecUtil_sidecar_1.vecUtil.rotate(direction, body2.rotation());
                    minigolfCreatures_sidecar_1.minigolfCreatures.flingCreature(entity, direction, 0.5 / 120);
                }
                if (creature2.data.creatureType === 'slope2') {
                    console.log(namespace, 'creature hit slope2');
                    var direction = vecUtil_sidecar_1.vecUtil.create(-1, -1);
                    direction = vecUtil_sidecar_1.vecUtil.rotate(direction, body2.rotation());
                    minigolfCreatures_sidecar_1.minigolfCreatures.flingCreature(entity, direction, 0.5 / 120);
                }
            }
            // let c2 = phys.world.colliders.get(handle2)
            // This closure is called on each collider potentially
            // intersecting the collider `collider`.
        });
    };
    for (var iEntity = 0; iEntity < enemiesAndPlayer.length; iEntity++) {
        _loop_1(iEntity);
    }
}
exports.processIntersections = processIntersections;
